import { ContactusForm } from "@modules/study/common";
import { Grid } from "@mui/material";
import { htmlParse } from "@unisearch/helpers";
import { getAssets } from "@unisearch/helpers";
import React from "react";
import { ReactSVG } from "react-svg";
import styles from "./uni_contact.module.scss";

export const UniContact = ({
  uniProfileData,
  contactOverviewText,
  isPopup = false,
}) => {
  return (
    <>
      <section className={styles.section_contact}>
        <div className="container">
          <div className={styles.title_wrapper}>
            <h2>Contact the University</h2>
            {contactOverviewText ? (
              htmlParse(contactOverviewText)
            ) : (
              <p className={styles.short_description}>
                You can connect with {uniProfileData?.universityName} directly
                through your UniSearch dashboard, or reach out to them through
                the options below!
              </p>
            )}
          </div>

          <div className={styles.address_card_wrapper}>
            <Grid
              container
              spacing={3}
              alignItems="stretch"
              justifyContent="center"
            >
              {uniProfileData?.address && (
                <Grid item xs={12} sm={6} md={4}>
                  <div className={styles.address_card}>
                    <ReactSVG
                      className={styles.address_card_icon}
                      src={getAssets(
                        "assets/images/uni-profile/map-placeholder-icon.svg"
                      )}
                    />
                    <div className={styles.address_card_title}>Address</div>
                    <p className={styles.address_card_desc}>
                      {uniProfileData?.address}
                    </p>
                  </div>
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={4}>
                <div className={styles.address_card}>
                  <ReactSVG
                    className={styles.address_card_icon}
                    src={getAssets("assets/images/uni-profile/phone-icon.svg")}
                  />
                  <div className={styles.address_card_title}>Contact</div>
                  <p className={styles.address_card_desc}>
                    {uniProfileData?.phone && (
                      <>
                        <a href={`tel:${uniProfileData?.phone}`}>
                          Phone: {uniProfileData?.phone} <br />
                        </a>
                      </>
                    )}
                    {uniProfileData?.email && (
                      <>
                        Email:{" "}
                        <a href={`mailto:${uniProfileData?.email}`}>
                          {uniProfileData?.email}
                        </a>
                      </>
                    )}
                  </p>
                </div>
              </Grid>

              {uniProfileData?.website && (
                <Grid item xs={12} sm={6} md={4}>
                  <div className={styles.address_card}>
                    <ReactSVG
                      className={styles.address_card_icon}
                      src={getAssets(
                        "assets/images/uni-profile/worldwide-icon.svg"
                      )}
                    />
                    <div className={styles.address_card_title}>Website</div>
                    <p className={styles.address_card_desc}>
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={uniProfileData?.website}
                      >
                        {uniProfileData?.website}
                      </a>
                    </p>
                  </div>
                </Grid>
              )}
            </Grid>
          </div>

          {uniProfileData?.location && (
            <div className={styles.map_wrapper}>
              {htmlParse(uniProfileData.location)}
            </div>
          )}
        </div>
      </section>
      {isPopup == false && (
        <section>
          <div className="container">
            <ContactusForm
              formFor="university"
              universityId={uniProfileData?.universityId}
              uniProfileData={uniProfileData}
              className={styles.contact_form}
            />
          </div>
        </section>
      )}
    </>
  );
};

export default UniContact;
